import React, { useEffect, Fragment } from "react";
import { useAdministrativo } from "../../hooks/useAdministrativo"; // Ajuste o path do hook

export default function AuditoriaProdutividade() {
  const {
    dadosProdutividade,
    loadingProdutividade,
    usuarioExpandidoProd,
    carregarProdutividade,
    toggleExpandirProd
  } = useAdministrativo();

  useEffect(() => {
    carregarProdutividade();
  }, [carregarProdutividade]);

  const formatarNomeUpper = (nome) => (nome ? String(nome).toUpperCase() : "SISTEMA");

  const formatarData = (dataString) => {
    if (!dataString) return "-";
    const date = new Date(dataString);
    if (isNaN(date.getTime())) return "-";
    return date.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  return (
    <div className="container-fluid p-3">
      <h2>Relatório de Produtividade da Equipe</h2>

      {loadingProdutividade ? (
        <p>Carregando dados de produtividade...</p>
      ) : dadosProdutividade.length === 0 ? (
        <p>Nenhum dado de produtividade disponível.</p>
      ) : (
        <table className="table table-hover align-middle">
          <thead>
            <tr>
              <th style={{ width: "40px" }}></th>
              <th>Colaborador</th>
              <th>Função</th>
              <th>Criações</th>
              <th>Atualizações</th>
              <th>Exclusões</th>
              <th>Total de Ações</th>
              <th>Última Atividade</th>
            </tr>
          </thead>
          <tbody>
            {dadosProdutividade.map((item, index) => {
              const userId = item._id?.userId || item._id;
              const keyUnica = userId ? `user-${userId}` : `user-index-${index}`;
              const estaExpandido = usuarioExpandidoProd === userId;

              const nomeUsuario = item._id?.userNome || "SISTEMA";
              const roleUsuario = item._id?.role;
              const historico = item.historico || [];

              return (
                <Fragment key={keyUnica}>
                  <tr
                    onClick={() => toggleExpandirProd(userId)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="text-center">{estaExpandido ? "▼" : "▶"}</td>
                    <td>{formatarNomeUpper(nomeUsuario)}</td>
                    <td>{roleUsuario ? roleUsuario.toUpperCase() : "-"}</td>
                    <td>{item.criacoes || 0}</td>
                    <td>{item.atualizacoes || 0}</td>
                    <td>{item.exclusoes || 0}</td>
                    <td>
                      <strong>{item.totalAcoes || 0}</strong>
                    </td>
                    <td>{formatarData(item.ultimaAtividade)}</td>
                  </tr>

                  {/* Linha Expandida com Histórico */}
                  {estaExpandido && (
                    <tr>
                      <td colSpan="8" className="p-3 bg-light">
                        {historico.length === 0 ? (
                          <p className="mb-0 text-muted">
                            Nenhum registro de histórico detalhado encontrado para este colaborador.
                          </p>
                        ) : (
                          <div className="table-responsive">
                            <table className="table table-sm table-bordered bg-white mb-0">
                              <thead>
                                <tr>
                                  <th>Ação</th>
                                  <th>Entidade</th>
                                  <th>Detalhes</th>
                                  <th>Data/Hora</th>
                                </tr>
                              </thead>
                              <tbody>
                                {historico.map((log, logIdx) => (
                                  <tr key={log._id || `log-${logIdx}`}>
                                    <td>{log.action || "-"}</td>
                                    <td>{log.entityType || "-"}</td>
                                    <td>
                                      {typeof log.details === "object"
                                        ? JSON.stringify(log.details)
                                        : log.details || "-"}
                                    </td>
                                    <td>{formatarData(log.createdAt)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                </Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}